import { useState } from "react";
import axios from "axios";
import { API } from "../App";

// Comprehensive country codes list (alphabetical by country name)
const COUNTRY_CODES = [
  { code: "+93", country: "Afghanistan" },
  { code: "+355", country: "Albania" },
  { code: "+213", country: "Algeria" },
  { code: "+376", country: "Andorra" },
  { code: "+244", country: "Angola" },
  { code: "+1", country: "Antigua & Barbuda" },
  { code: "+54", country: "Argentina" },
  { code: "+374", country: "Armenia" },
  { code: "+61", country: "Australia" },
  { code: "+43", country: "Austria" },
  { code: "+994", country: "Azerbaijan" },
  { code: "+1", country: "Bahamas" },
  { code: "+973", country: "Bahrain" },
  { code: "+880", country: "Bangladesh" },
  { code: "+1", country: "Barbados" },
  { code: "+375", country: "Belarus" },
  { code: "+32", country: "Belgium" },
  { code: "+501", country: "Belize" },
  { code: "+229", country: "Benin" },
  { code: "+975", country: "Bhutan" },
  { code: "+591", country: "Bolivia" },
  { code: "+387", country: "Bosnia & Herzegovina" },
  { code: "+267", country: "Botswana" },
  { code: "+55", country: "Brazil" },
  { code: "+673", country: "Brunei" },
  { code: "+359", country: "Bulgaria" },
  { code: "+226", country: "Burkina Faso" },
  { code: "+257", country: "Burundi" },
  { code: "+855", country: "Cambodia" },
  { code: "+237", country: "Cameroon" },
  { code: "+1", country: "Canada" },
  { code: "+238", country: "Cape Verde" },
  { code: "+236", country: "Central African Republic" },
  { code: "+235", country: "Chad" },
  { code: "+56", country: "Chile" },
  { code: "+86", country: "China" },
  { code: "+57", country: "Colombia" },
  { code: "+269", country: "Comoros" },
  { code: "+243", country: "Congo (DRC)" },
  { code: "+242", country: "Congo (Republic)" },
  { code: "+506", country: "Costa Rica" },
  { code: "+385", country: "Croatia" },
  { code: "+53", country: "Cuba" },
  { code: "+357", country: "Cyprus" },
  { code: "+420", country: "Czech Republic" },
  { code: "+45", country: "Denmark" },
  { code: "+253", country: "Djibouti" },
  { code: "+1", country: "Dominica" },
  { code: "+1", country: "Dominican Republic" },
  { code: "+593", country: "Ecuador" },
  { code: "+20", country: "Egypt" },
  { code: "+503", country: "El Salvador" },
  { code: "+240", country: "Equatorial Guinea" },
  { code: "+291", country: "Eritrea" },
  { code: "+372", country: "Estonia" },
  { code: "+251", country: "Ethiopia" },
  { code: "+679", country: "Fiji" },
  { code: "+358", country: "Finland" },
  { code: "+33", country: "France" },
  { code: "+241", country: "Gabon" },
  { code: "+220", country: "Gambia" },
  { code: "+995", country: "Georgia" },
  { code: "+49", country: "Germany" },
  { code: "+233", country: "Ghana" },
  { code: "+30", country: "Greece" },
  { code: "+1", country: "Grenada" },
  { code: "+502", country: "Guatemala" },
  { code: "+224", country: "Guinea" },
  { code: "+245", country: "Guinea-Bissau" },
  { code: "+592", country: "Guyana" },
  { code: "+509", country: "Haiti" },
  { code: "+504", country: "Honduras" },
  { code: "+852", country: "Hong Kong" },
  { code: "+36", country: "Hungary" },
  { code: "+354", country: "Iceland" },
  { code: "+91", country: "India" },
  { code: "+62", country: "Indonesia" },
  { code: "+98", country: "Iran" },
  { code: "+964", country: "Iraq" },
  { code: "+353", country: "Ireland" },
  { code: "+972", country: "Israel" },
  { code: "+39", country: "Italy" },
  { code: "+225", country: "Ivory Coast" },
  { code: "+1", country: "Jamaica" },
  { code: "+81", country: "Japan" },
  { code: "+962", country: "Jordan" },
  { code: "+7", country: "Kazakhstan" },
  { code: "+254", country: "Kenya" },
  { code: "+686", country: "Kiribati" },
  { code: "+965", country: "Kuwait" },
  { code: "+996", country: "Kyrgyzstan" },
  { code: "+856", country: "Laos" },
  { code: "+371", country: "Latvia" },
  { code: "+961", country: "Lebanon" },
  { code: "+266", country: "Lesotho" },
  { code: "+231", country: "Liberia" },
  { code: "+218", country: "Libya" },
  { code: "+423", country: "Liechtenstein" },
  { code: "+370", country: "Lithuania" },
  { code: "+352", country: "Luxembourg" },
  { code: "+853", country: "Macau" },
  { code: "+389", country: "Macedonia" },
  { code: "+261", country: "Madagascar" },
  { code: "+265", country: "Malawi" },
  { code: "+60", country: "Malaysia" },
  { code: "+960", country: "Maldives" },
  { code: "+223", country: "Mali" },
  { code: "+356", country: "Malta" },
  { code: "+692", country: "Marshall Islands" },
  { code: "+222", country: "Mauritania" },
  { code: "+230", country: "Mauritius" },
  { code: "+52", country: "Mexico" },
  { code: "+691", country: "Micronesia" },
  { code: "+373", country: "Moldova" },
  { code: "+377", country: "Monaco" },
  { code: "+976", country: "Mongolia" },
  { code: "+382", country: "Montenegro" },
  { code: "+212", country: "Morocco" },
  { code: "+258", country: "Mozambique" },
  { code: "+95", country: "Myanmar" },
  { code: "+264", country: "Namibia" },
  { code: "+674", country: "Nauru" },
  { code: "+977", country: "Nepal" },
  { code: "+31", country: "Netherlands" },
  { code: "+64", country: "New Zealand" },
  { code: "+505", country: "Nicaragua" },
  { code: "+227", country: "Niger" },
  { code: "+234", country: "Nigeria" },
  { code: "+850", country: "North Korea" },
  { code: "+47", country: "Norway" },
  { code: "+968", country: "Oman" },
  { code: "+92", country: "Pakistan" },
  { code: "+680", country: "Palau" },
  { code: "+970", country: "Palestine" },
  { code: "+507", country: "Panama" },
  { code: "+675", country: "Papua New Guinea" },
  { code: "+595", country: "Paraguay" },
  { code: "+51", country: "Peru" },
  { code: "+63", country: "Philippines" },
  { code: "+48", country: "Poland" },
  { code: "+351", country: "Portugal" },
  { code: "+974", country: "Qatar" },
  { code: "+40", country: "Romania" },
  { code: "+7", country: "Russia" },
  { code: "+250", country: "Rwanda" },
  { code: "+1", country: "Saint Kitts & Nevis" },
  { code: "+1", country: "Saint Lucia" },
  { code: "+1", country: "Saint Vincent" },
  { code: "+685", country: "Samoa" },
  { code: "+378", country: "San Marino" },
  { code: "+239", country: "Sao Tome & Principe" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+221", country: "Senegal" },
  { code: "+381", country: "Serbia" },
  { code: "+248", country: "Seychelles" },
  { code: "+232", country: "Sierra Leone" },
  { code: "+65", country: "Singapore" },
  { code: "+421", country: "Slovakia" },
  { code: "+386", country: "Slovenia" },
  { code: "+677", country: "Solomon Islands" },
  { code: "+252", country: "Somalia" },
  { code: "+27", country: "South Africa" },
  { code: "+82", country: "South Korea" },
  { code: "+211", country: "South Sudan" },
  { code: "+34", country: "Spain" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+249", country: "Sudan" },
  { code: "+597", country: "Suriname" },
  { code: "+268", country: "Swaziland" },
  { code: "+46", country: "Sweden" },
  { code: "+41", country: "Switzerland" },
  { code: "+963", country: "Syria" },
  { code: "+886", country: "Taiwan" },
  { code: "+992", country: "Tajikistan" },
  { code: "+255", country: "Tanzania" },
  { code: "+66", country: "Thailand" },
  { code: "+670", country: "Timor-Leste" },
  { code: "+228", country: "Togo" },
  { code: "+676", country: "Tonga" },
  { code: "+1", country: "Trinidad & Tobago" },
  { code: "+216", country: "Tunisia" },
  { code: "+90", country: "Turkey" },
  { code: "+993", country: "Turkmenistan" },
  { code: "+688", country: "Tuvalu" },
  { code: "+256", country: "Uganda" },
  { code: "+380", country: "Ukraine" },
  { code: "+971", country: "United Arab Emirates" },
  { code: "+44", country: "United Kingdom" },
  { code: "+1", country: "United States" },
  { code: "+598", country: "Uruguay" },
  { code: "+998", country: "Uzbekistan" },
  { code: "+678", country: "Vanuatu" },
  { code: "+379", country: "Vatican City" },
  { code: "+58", country: "Venezuela" },
  { code: "+84", country: "Vietnam" },
  { code: "+967", country: "Yemen" },
  { code: "+260", country: "Zambia" },
  { code: "+263", country: "Zimbabwe" },
  { code: "", country: "Other" },
];

// Comprehensive countries list (alphabetical)
const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda",
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain",
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
  "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros",
  "Congo (Democratic Republic)", "Congo (Republic)", "Costa Rica", "Croatia", "Cuba",
  "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
  "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia",
  "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
  "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India",
  "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica",
  "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait",
  "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
  "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Madagascar", "Malawi",
  "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
  "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro",
  "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
  "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia",
  "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea",
  "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania",
  "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
  "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
  "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea",
  "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland",
  "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo",
  "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
  "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen", "Zambia", "Zimbabwe", "Other"
];

// Fee structure
const FEES = {
  "LIRSS Only": {
    Consultant: 150,
    Trainee: 130,
    Nurse: 90
  },
  "LIRSS + LIBSS Combo": {
    Consultant: 325,
    Trainee: 240,
    Nurse: 160
  }
};

// LIBSS Only fees: keyed by delegate label, then attendance days
const LIBSS_FEES = {
  "Consultant (Doctor)": { "One Day": 200, "Two Days": 250 },
  "Trainee (Doctor)": { "One Day": 125, "Two Days": 175 },
  "Allied Health Professional": { "One Day": 99, "Two Days": 145 }
};

const LIBSS_DELEGATE_TYPES = [
  "Consultant (Doctor)",
  "Trainee (Doctor)",
  "Allied Health Professional"
];

const LIBSS_DELEGATE_SUBLABELS = {
  "Allied Health Professional": "Dieticians / Psychologists / Nursing"
};

const ATTENDANCE_DAYS = ["One Day", "Two Days"];
const LIBSS_DATES = ["November 26, 2026", "November 27, 2026"];

const TITLES = ["Mr", "Mrs", "Ms", "Dr", "Prof"];
const DELEGATE_TYPES = ["Consultant", "Trainee", "Nurse"];

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+44",
    phone: "",
    hospital: "",
    country: "",
    registrationType: "",
    delegateType: "",
    attendanceDays: "",
    attendanceDate: "",
    subscribeUpdates: false,
    gdprConsent: false
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleRegistrationTypeSelect = (type) => {
    setFormData(prev => ({
      ...prev,
      registrationType: type,
      delegateType: "",
      attendanceDays: "",
      attendanceDate: ""
    }));
  };

  const handleDelegateTypeSelect = (type) => {
    setFormData(prev => ({
      ...prev,
      delegateType: type
    }));
  };

  const handleAttendanceDaysSelect = (days) => {
    setFormData(prev => ({
      ...prev,
      attendanceDays: days,
      // Reset any previously chosen date when switching modes
      attendanceDate: days === "Two Days" ? "" : prev.attendanceDate
    }));
  };

  const handleAttendanceDateSelect = (date) => {
    setFormData(prev => ({
      ...prev,
      attendanceDate: date
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Only send LIBSS-specific fields for LIBSS Only registrations
      const isLibssPayload = formData.registrationType === "LIBSS Only";
      const payload = {
        ...formData,
        attendanceDays: isLibssPayload ? formData.attendanceDays : null,
        attendanceDate:
          isLibssPayload && formData.attendanceDays === "One Day"
            ? formData.attendanceDate
            : null
      };

      const response = await axios.post(`${API}/registrations/`, payload, {
        headers: {
          'X-Frontend-Origin': window.location.origin
        }
      });

      if (response.data.success && response.data.data.checkout_url) {
        window.location.href = response.data.data.checkout_url;
      }
    } catch (err) {
      setError(err.response?.data?.detail || "An error occurred. Please try again.");
      setLoading(false);
    }
  };

  const isLibss = formData.registrationType === "LIBSS Only";
  const isCombo = formData.registrationType === "LIRSS + LIBSS Combo";

  const selectedFee = (() => {
    if (isLibss) {
      if (formData.delegateType && formData.attendanceDays) {
        return LIBSS_FEES[formData.delegateType]?.[formData.attendanceDays] ?? null;
      }
      return null;
    }
    if (formData.registrationType && formData.delegateType) {
      return FEES[formData.registrationType]?.[formData.delegateType] ?? null;
    }
    return null;
  })();

  // Whether the user has completed the mandatory selections to proceed to Step 3
  const selectionsComplete = isLibss
    ? Boolean(
        formData.delegateType &&
        formData.attendanceDays &&
        (formData.attendanceDays === "Two Days" || Boolean(formData.attendanceDate))
      )
    : Boolean(formData.delegateType);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#070e1e] to-[#112447]">
      {/* Header / Hero */}
      <header className="relative overflow-hidden border-b border-[#1e3a66]">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1549483249-f0b359d1e289?crop=entropy&cs=srgb&fm=jpg&q=85')" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#003f5c]/95 via-[#1d4382]/90 to-[#003f5c]/95" />
        <div className="relative max-w-3xl mx-auto px-4 py-7 sm:py-10">

          {/* Mobile: logos side-by-side on one row, title below */}
          {/* Desktop: logo | title | logo */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4 mb-4">

            {/* Mobile: both logos in one compact row */}
            <div className="flex sm:hidden items-center justify-between gap-3">
              <div className="flex flex-col items-center">
                <div className="bg-white/95 rounded-lg p-1.5 shadow-lg border border-white/20">
                  <img src="https://lirss.org/wp-content/uploads/2026/03/LirssLoog.png" alt="LIRSS" className="h-7 w-auto" data-testid="lirss-logo" />
                </div>
                <p className="text-[#a8c5f0] text-[10px] mt-1 font-medium whitespace-nowrap">Nov 25, 2026</p>
              </div>
              <div className="flex-1 text-center">
                <h1 className="font-heading text-xl font-extrabold text-white tracking-tight leading-tight">
                  LIBSS | LIRSS<br />Registration 2026
                </h1>
                <p className="text-[#a8c5f0] mt-0.5 text-xs">Homerton University Hospital, London</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="bg-white/95 rounded-lg p-1.5 shadow-lg border border-white/20">
                  <img src="https://customer-assets-eiarnc6j.emergentagent.net/job_multi-conf-deploy/artifacts/060p67b5_Libss2026Logo-1%20%281%29.png" alt="LIBSS 2026" className="h-7 w-auto" data-testid="libss-logo" />
                </div>
                <p className="text-[#a8c5f0] text-[10px] mt-1 font-medium whitespace-nowrap">Nov 26–27, 2026</p>
              </div>
            </div>

            {/* Desktop: LIRSS logo + title left, LIBSS logo right */}
            <div className="hidden sm:flex items-center gap-4">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="bg-white/95 rounded-xl p-3 inline-block shadow-lg border border-white/20">
                  <img src="https://lirss.org/wp-content/uploads/2026/03/LirssLoog.png" alt="LIRSS" className="h-11 w-auto" data-testid="lirss-logo" />
                </div>
                <p className="text-[#a8c5f0] text-xs mt-1.5 font-medium whitespace-nowrap">November 25, 2026</p>
              </div>
              <div>
                <h1 className="font-heading text-3xl font-extrabold text-white tracking-tight">
                  LIBSS | LIRSS Registration 2026
                </h1>
                <p className="text-[#a8c5f0] mt-1 text-base">Homerton University Hospital, London</p>
              </div>
            </div>
            <div className="hidden sm:flex flex-col items-center flex-shrink-0">
              <div className="bg-white/95 rounded-xl p-3 inline-block shadow-lg border border-white/20">
                <img src="https://customer-assets-eiarnc6j.emergentagent.net/job_multi-conf-deploy/artifacts/060p67b5_Libss2026Logo-1%20%281%29.png" alt="LIBSS 2026" className="h-11 w-auto" data-testid="libss-logo" />
              </div>
              <p className="text-[#a8c5f0] text-xs mt-1.5 font-medium whitespace-nowrap">November 26-27, 2026</p>
            </div>

          </div>

          <div className="text-center sm:flex sm:justify-center">
            <span className="inline-block bg-gradient-to-r from-[#ffa500] to-[#c96100] text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide shadow-md">
              Regular Fees Apply w.e.f 15th October 2026
            </span>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-4 py-8">
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="registration-form">
          {error && (
            <div className="bg-[#ef4036]/15 border border-[#ef4036] text-red-200 px-4 py-3 rounded-lg" data-testid="error-message">
              {error}
            </div>
          )}

          {/* Step 1: Select Registration Type */}
          <div className="bg-[#0f224a]/80 backdrop-blur-md rounded-2xl border border-[#1e3a66] p-6 sm:p-8 shadow-xl shadow-black/40">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-[#ef4036] text-white font-extrabold flex items-center justify-center text-base shadow-md shadow-red-900/50">1</div>
              <h2 className="font-heading text-xl font-bold text-white">Select Registration Type</h2>
            </div>
            <p className="text-[#94a3b8] text-sm mb-4">All fees below reflect our <span className="text-white font-semibold">Regular</span> offer.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* LIRSS Only */}
              <div 
                onClick={() => handleRegistrationTypeSelect("LIRSS Only")}
                className={`cursor-pointer p-5 rounded-xl transition-all duration-200 border-2 ${
                  formData.registrationType === "LIRSS Only" 
                    ? 'bg-[#1d4382]/40 border-[#4a90e2] ring-2 ring-[#4a90e2]/30 shadow-lg shadow-blue-900/30' 
                    : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                }`}
                data-testid="registration-type-lirss"
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    formData.registrationType === "LIRSS Only" ? 'border-[#4a90e2] bg-[#4a90e2]' : 'border-slate-500'
                  }`}>
                    {formData.registrationType === "LIRSS Only" && (
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                  <span className="text-lg font-semibold text-white">LIRSS Only</span>
                </div>
                <p className="text-[#4a90e2] text-sm font-medium mb-1">November 25, 2026</p>
                <p className="text-[#94a3b8] text-sm">1 Day Conference</p>
              </div>

              {/* LIBSS Only */}
              <div 
                onClick={() => handleRegistrationTypeSelect("LIBSS Only")}
                className={`cursor-pointer p-5 rounded-xl transition-all duration-200 border-2 ${
                  formData.registrationType === "LIBSS Only" 
                    ? 'bg-[#003f5c]/40 border-[#4a90e2] ring-2 ring-[#4a90e2]/30 shadow-lg shadow-sky-900/30' 
                    : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                }`}
                data-testid="registration-type-libss"
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    formData.registrationType === "LIBSS Only" ? 'border-[#4a90e2] bg-[#4a90e2]' : 'border-slate-500'
                  }`}>
                    {formData.registrationType === "LIBSS Only" && (
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                  <span className="text-lg font-semibold text-white">LIBSS 2026 (only)</span>
                </div>
                <p className="text-[#4a90e2] text-sm font-medium mb-1">November 26-27, 2026</p>
                <p className="text-[#94a3b8] text-sm">1 or 2 Day Attendance</p>
              </div>

              {/* LIRSS + LIBSS Combo */}
              <div 
                onClick={() => handleRegistrationTypeSelect("LIRSS + LIBSS Combo")}
                className={`cursor-pointer p-5 rounded-xl transition-all duration-200 border-2 ${
                  formData.registrationType === "LIRSS + LIBSS Combo" 
                    ? 'bg-gradient-to-br from-[#1d4382]/50 to-[#003f5c]/50 border-[#ef4036] ring-2 ring-[#ef4036]/30 shadow-lg shadow-red-900/30' 
                    : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                }`}
                data-testid="registration-type-combo"
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    formData.registrationType === "LIRSS + LIBSS Combo" ? 'border-[#ef4036] bg-[#ef4036]' : 'border-slate-500'
                  }`}>
                    {formData.registrationType === "LIRSS + LIBSS Combo" && (
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-lg font-semibold text-white">LIRSS + LIBSS Combo</span>
                    <span className="text-xs bg-[#ef4036] text-white px-2 py-0.5 rounded-full">SAVE</span>
                  </div>
                </div>
                <p className="text-[#ef4036] text-sm font-medium mb-1">November 25-27, 2026</p>
                <p className="text-[#94a3b8] text-sm">3 Days Conference</p>
              </div>
            </div>

            <p className="text-[#94a3b8] text-xs mt-4 leading-relaxed border-t border-[#1e3a66] pt-3">
              <span className="text-[#a8c5f0] font-semibold">Cancellations &amp; Refunds:</span> A cancellation charge of £30 will be applicable for any cancellation made on or before 30th September 2026. No refund will be applicable for cancellations after this date.
            </p>
          </div>

          {/* Step 2: Select Delegate Type */}
          {formData.registrationType && !isLibss && (
            <div className="bg-[#0f224a]/80 backdrop-blur-md rounded-2xl border border-[#1e3a66] p-6 sm:p-8 shadow-xl shadow-black/40 animate-fadeIn">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 rounded-full bg-[#ef4036] text-white font-extrabold flex items-center justify-center text-base shadow-md shadow-red-900/50">2</div>
                <h2 className="font-heading text-xl font-bold text-white">Select Delegate Type</h2>
              </div>
              
              <div className="grid grid-cols-3 gap-3">
                {DELEGATE_TYPES.map((type) => {
                  const fee = FEES[formData.registrationType]?.[type];
                  const isSelected = formData.delegateType === type;
                  
                  return (
                    <div 
                      key={type}
                      onClick={() => handleDelegateTypeSelect(type)}
                      className={`cursor-pointer p-4 rounded-xl transition-all duration-200 border-2 text-center ${
                        isSelected
                          ? isCombo 
                            ? 'bg-gradient-to-br from-[#1d4382]/50 to-[#003f5c]/50 border-[#ef4036]' 
                            : 'bg-[#1d4382]/40 border-[#4a90e2]'
                          : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                      }`}
                      data-testid={`delegate-type-${type.toLowerCase()}`}
                    >
                      <div className={`w-4 h-4 rounded-full border-2 mx-auto mb-2 ${
                        isSelected 
                          ? isCombo
                            ? 'border-[#ef4036] bg-[#ef4036]'
                            : 'border-[#4a90e2] bg-[#4a90e2]'
                          : 'border-slate-500'
                      }`}>
                        {isSelected && (
                          <svg className="w-full h-full text-white p-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                      </div>
                      <div className="text-white font-medium">{type}</div>
                      <div className={`text-lg font-bold mt-1 ${
                        isSelected 
                          ? isCombo ? 'text-[#ff8a80]' : 'text-[#8ab6f0]'
                          : 'text-[#94a3b8]'
                      }`}>
                        £{fee}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Step 2 (LIBSS): Delegate Type + Attendance Days */}
          {isLibss && (
            <div className="bg-[#0f224a]/80 backdrop-blur-md rounded-2xl border border-[#1e3a66] p-6 sm:p-8 shadow-xl shadow-black/40 animate-fadeIn">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 rounded-full bg-[#ef4036] text-white font-extrabold flex items-center justify-center text-base shadow-md shadow-red-900/50">2</div>
                <h2 className="font-heading text-xl font-bold text-white">Select Delegate Type & Attendance</h2>
              </div>

              {/* Delegate Type */}
              <div className="mb-6">
                <p className="text-[#c3d3ea] text-sm font-medium mb-3">Delegate Type</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  {LIBSS_DELEGATE_TYPES.map((type) => {
                    const isSelected = formData.delegateType === type;
                    const sublabel = LIBSS_DELEGATE_SUBLABELS[type];
                    return (
                      <div
                        key={type}
                        onClick={() => handleDelegateTypeSelect(type)}
                        className={`cursor-pointer p-4 rounded-xl transition-all duration-200 border-2 ${
                          isSelected
                            ? 'bg-[#003f5c]/40 border-[#4a90e2]'
                            : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                        }`}
                        data-testid={`libss-delegate-${type.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                      >
                        <div className={`w-4 h-4 rounded-full border-2 mb-2 ${
                          isSelected ? 'border-[#4a90e2] bg-[#4a90e2]' : 'border-slate-500'
                        }`}>
                          {isSelected && (
                            <svg className="w-full h-full text-white p-0.5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          )}
                        </div>
                        <div className="text-white font-medium leading-tight">{type}</div>
                        {sublabel && (
                          <div className="text-[#94a3b8] text-xs mt-1">{sublabel}</div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Attendance Days */}
              {formData.delegateType && (
                <div className="animate-fadeIn">
                  <p className="text-[#c3d3ea] text-sm font-medium mb-3">Attendance</p>
                  <div className="grid grid-cols-2 gap-3">
                    {ATTENDANCE_DAYS.map((days) => {
                      const isSelected = formData.attendanceDays === days;
                      const fee = LIBSS_FEES[formData.delegateType]?.[days];
                      return (
                        <div
                          key={days}
                          onClick={() => handleAttendanceDaysSelect(days)}
                          className={`cursor-pointer p-4 rounded-xl transition-all duration-200 border-2 text-center ${
                            isSelected
                              ? 'bg-[#003f5c]/40 border-[#4a90e2]'
                              : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                          }`}
                          data-testid={`libss-days-${days.toLowerCase().replace(' ', '-')}`}
                        >
                          <div className={`w-4 h-4 rounded-full border-2 mx-auto mb-2 ${
                            isSelected ? 'border-[#4a90e2] bg-[#4a90e2]' : 'border-slate-500'
                          }`}>
                            {isSelected && (
                              <svg className="w-full h-full text-white p-0.5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            )}
                          </div>
                          <div className="text-white font-medium">{days}</div>
                          <div className={`text-lg font-bold mt-1 ${
                            isSelected ? 'text-[#8ab6f0]' : 'text-[#94a3b8]'
                          }`}>
                            £{fee}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Which date (only for One Day) */}
              {formData.delegateType && formData.attendanceDays === "One Day" && (
                <div className="mt-6 animate-fadeIn">
                  <p className="text-[#c3d3ea] text-sm font-medium mb-3">Which day will you attend?</p>
                  <div className="grid grid-cols-2 gap-3">
                    {LIBSS_DATES.map((date) => {
                      const isSelected = formData.attendanceDate === date;
                      return (
                        <div
                          key={date}
                          onClick={() => handleAttendanceDateSelect(date)}
                          className={`cursor-pointer p-4 rounded-xl transition-all duration-200 border-2 text-center ${
                            isSelected
                              ? 'bg-[#003f5c]/40 border-[#4a90e2]'
                              : 'bg-[#0b1736]/70 border-[#1e3a66] hover:border-[#4a90e2] hover:-translate-y-0.5'
                          }`}
                          data-testid={`libss-date-${date.split(',')[0].toLowerCase().replace(/\s+/g, '-')}`}
                        >
                          <div className={`w-4 h-4 rounded-full border-2 mx-auto mb-2 ${
                            isSelected ? 'border-[#4a90e2] bg-[#4a90e2]' : 'border-slate-500'
                          }`}>
                            {isSelected && (
                              <svg className="w-full h-full text-white p-0.5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            )}
                          </div>
                          <div className="text-white font-medium">{date}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Fee Display */}
          {selectedFee && (
            <div className="rounded-xl p-4 border-2 border-[#ef4036] bg-gradient-to-r from-[#1d4382] to-[#003f5c] shadow-2xl" data-testid="fee-display">
              <div className="flex justify-between items-center">
                <div>
                  <span className="text-white font-medium">{formData.registrationType}</span>
                  <span className="text-[#4a90e2] mx-2">•</span>
                  <span className="text-[#c3d3ea]">{formData.delegateType}</span>
                  {isLibss && formData.attendanceDays && (
                    <>
                      <span className="text-[#4a90e2] mx-2">•</span>
                      <span className="text-[#c3d3ea]">{formData.attendanceDays}</span>
                      {formData.attendanceDays === "One Day" && formData.attendanceDate && (
                        <>
                          <span className="text-[#4a90e2] mx-2">•</span>
                          <span className="text-[#c3d3ea]">{formData.attendanceDate}</span>
                        </>
                      )}
                    </>
                  )}
                </div>
                <div className="text-2xl font-bold text-white">£{selectedFee}</div>
              </div>
            </div>
          )}

          {/* Step 3: Personal Details */}
          {selectionsComplete && (
            <div className="bg-[#0f224a]/80 backdrop-blur-md rounded-2xl border border-[#1e3a66] p-6 sm:p-8 shadow-xl shadow-black/40 animate-fadeIn">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 rounded-full bg-[#ef4036] text-white font-extrabold flex items-center justify-center text-base shadow-md shadow-red-900/50">3</div>
                <h2 className="font-heading text-xl font-bold text-white">Personal Details</h2>
              </div>
              
              <div className="space-y-4">
                {/* Title, First Name, Last Name */}
                <div className="grid grid-cols-6 gap-4">
                  <div className="col-span-1">
                    <label className="block text-[#c3d3ea] text-sm font-medium mb-2">Title *</label>
                    <select
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      required
                      className="w-full bg-[#0b1736] border border-[#2c4875] rounded-lg px-3 py-3 text-white focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                      data-testid="title-select"
                    >
                      <option value="">Select</option>
                      {TITLES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div className="col-span-2">
                    <label className="block text-[#c3d3ea] text-sm font-medium mb-2">First Name *</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      placeholder="First name"
                      className="w-full bg-[#0b1736] border border-[#2c4875] rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                      data-testid="firstname-input"
                    />
                  </div>
                  <div className="col-span-3">
                    <label className="block text-[#c3d3ea] text-sm font-medium mb-2">Last Name *</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      placeholder="Last name"
                      className="w-full bg-[#0b1736] border border-[#2c4875] rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                      data-testid="lastname-input"
                    />
                  </div>
                </div>

                {/* Email */}
                <div>
                  <label className="block text-[#c3d3ea] text-sm font-medium mb-2">Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                    className="w-full bg-[#0b1736] border border-[#2c4875] rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                    data-testid="email-input"
                  />
                </div>

                {/* Phone with Country Code */}
                <div>
                  <label className="block text-[#c3d3ea] text-sm font-medium mb-2">Phone Number *</label>
                  <div className="flex gap-2">
                    <select
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      className="w-48 bg-[#0b1736] border border-[#2c4875] rounded-lg px-2 py-3 text-white focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2] text-sm"
                      data-testid="country-code-select"
                    >
                      <option value="">Select code</option>
                      {COUNTRY_CODES.map(({ code, country }, index) => (
                        <option key={`${code}-${index}`} value={code}>
                          {code ? `${code} ${country}` : `-- ${country} --`}
                        </option>
                      ))}
                    </select>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="Phone number"
                      className="flex-1 bg-[#0b1736] border border-[#2c4875] rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                      data-testid="phone-input"
                    />
                  </div>
                </div>

                {/* Institution/Hospital */}
                <div>
                  <label className="block text-[#c3d3ea] text-sm font-medium mb-2">Institution / Hospital *</label>
                  <input
                    type="text"
                    name="hospital"
                    value={formData.hospital}
                    onChange={handleChange}
                    required
                    placeholder="Enter your institution or hospital name"
                    className="w-full bg-[#0b1736] border border-[#2c4875] rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                    data-testid="hospital-input"
                  />
                </div>

                {/* Country */}
                <div>
                  <label className="block text-[#c3d3ea] text-sm font-medium mb-2">Country *</label>
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    className="w-full bg-[#0b1736] border border-[#2c4875] rounded-lg px-4 py-3 text-white focus:ring-2 focus:ring-[#4a90e2] focus:border-[#4a90e2]"
                    data-testid="country-select"
                  >
                    <option value="">Select Country</option>
                    {COUNTRIES.map(c => (
                      <option key={c} value={c}>
                        {c === "Other" ? "-- Other (not listed) --" : c}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Subscribe Updates */}
                <div className="flex items-center gap-3 pt-2">
                  <input
                    type="checkbox"
                    id="subscribeUpdates"
                    name="subscribeUpdates"
                    checked={formData.subscribeUpdates}
                    onChange={handleChange}
                    className="w-5 h-5 rounded bg-[#0b1736] border-[#2c4875] text-[#4a90e2] focus:ring-[#4a90e2]"
                    data-testid="subscribe-checkbox"
                  />
                  <label htmlFor="subscribeUpdates" className="text-[#c3d3ea]">
                    Subscribe for conference updates
                  </label>
                </div>

                {/* GDPR Consent */}
                <div className="flex items-start gap-3 bg-[#0b1736]/60 p-4 rounded-lg border border-[#1e3a66]">
                  <input
                    type="checkbox"
                    id="gdprConsent"
                    name="gdprConsent"
                    checked={formData.gdprConsent}
                    onChange={handleChange}
                    required
                    className="w-5 h-5 mt-1 rounded bg-[#0b1736] border-[#2c4875] text-[#4a90e2] focus:ring-[#4a90e2]"
                    data-testid="gdpr-checkbox"
                  />
                  <label htmlFor="gdprConsent" className="text-[#c3d3ea] text-sm">
                    I understand and agree to the privacy policy as listed on the Contact Us page of the{" "}
                    <a 
                      href="https://lirss.org" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#ffa500] hover:text-[#ffc266] underline"
                    >
                      lirss.org
                    </a>
                    {" "}*
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          {selectionsComplete && (
            <div className="pt-2">
              <button
                type="submit"
                disabled={loading || !formData.gdprConsent || !formData.firstName || !formData.lastName || !formData.email || !formData.country}
                className="w-full bg-[#ef4036] hover:bg-[#d93025] text-white font-bold py-4 px-6 rounded-xl shadow-xl shadow-red-600/30 hover:shadow-red-600/50 transition-all duration-200 uppercase tracking-wide disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="submit-button"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2 normal-case">
                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                    </svg>
                    Processing...
                  </span>
                ) : (
                  `Proceed to Payment - £${selectedFee || 0}`
                )}
              </button>
            </div>
          )}
        </form>

        {/* Footer */}
        <footer className="text-center mt-8 pb-8">
          <div className="flex items-center justify-center gap-4 mb-4">
            <a
              href="https://lirss.org"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-[#8ab6f0] hover:text-[#4a90e2] border border-[#2c4875] hover:border-[#4a90e2] rounded-full px-4 py-2 transition-colors"
              data-testid="visit-lirss-link"
            >
              Visit LIRSS.org
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
            <a
              href="https://libss.org"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-[#8ab6f0] hover:text-[#4a90e2] border border-[#2c4875] hover:border-[#4a90e2] rounded-full px-4 py-2 transition-colors"
              data-testid="visit-libss-link"
            >
              Visit LIBSS.org
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
          <p className="text-[#94a3b8] text-sm">For any queries, please contact: <a href="mailto:libssorg@gmail.com" className="text-[#ffa500] hover:text-[#ffc266]">libssorg@gmail.com</a></p>
          <p className="text-[#64748b] text-xs mt-4">© 2026 lirss.org. All rights reserved.</p>
        </footer>
      </main>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default RegistrationForm;
